import {
  buildStudyArchiveFilename,
  getStudyFilenameParts,
  sanitizeFilenamePart,
} from './filenameUtils';
import type { StudyDicomInstance } from './types';

export function buildStudyDicomZipFilename(
  studyInstanceUID: string,
  instances: StudyDicomInstance[],
  servicesManager?: AppTypes.ServicesManager
): string {
  const { studyDate, studyId } = getStudyFilenameParts(
    studyInstanceUID,
    instances,
    servicesManager
  );
  return buildStudyArchiveFilename(studyDate, studyId);
}

export function buildZipEntryPath(instance: StudyDicomInstance): string {
  const seriesPart = sanitizeFilenamePart(
    String(instance.SeriesNumber ?? instance.SeriesInstanceUID ?? 'series')
  );
  const instancePart = sanitizeFilenamePart(
    String(instance.InstanceNumber ?? instance.SOPInstanceUID ?? 'instance')
  );
  const sopPart = sanitizeFilenamePart(String(instance.SOPInstanceUID));

  return `Series-${seriesPart}/${instancePart}_${sopPart}.dcm`;
}

export { triggerBrowserDownload } from './triggerBrowserDownload';
